module.exports = __webpack_public_path__ + "static/media/icon35.b8086fee.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon35.png
// module id = 1765
// module chunks = 0 1